<template>
	<div>
		<v-badge :value="false" v-if="isEdocs" overlap>
			<template #badge>
				<icone-tooltip
					:cor="corIconeBadge"
					:tamanho="tamanhoIconeBadge"
					texto="Envio para o e-Docs em Processamento"
					icone="mdi-alert-circle"
				></icone-tooltip>
			</template>
			<menu-acoes
				class="tamanho-botao-menu-acoes"
				:style="{ '--width-menu': tamanhoLargura }"
				:outlined="outlined"
				:block="block"
				:disabled="disabled"
				:nome-botao="menuAcoesItens.nome"
				:nome="menuAcoesItens.nome"
				cor-icone="--v-error-base"
				:icone-primary="iconePrimary"
				:icone-secondary="iconeSecondary"
				:acoes-menu="menuAcoesItens.itens"
				:tamanho-icone-primary="tamanhoIconePrimary"
				:tamanho-icone-secondary="tamanhoIconeSecondary"
				:tamanho-icone-menu="tamanhoIconeMenu"
				:cor-de-fundo="corDeFundo"
				@acessar="acessar"
				@enviar-edocs="enviarEdocs"
			></menu-acoes>
		</v-badge>
		<botao-primario
			v-else
			id="BotaoVisualizarProcessoDigitalGenerico"
			:outlined="outlined"
			:block="block"
			:dark="dark"
			:disabled="disabled"
			:nome-botao="nomeBotao"
			:icone="icone"
			:tamanho-largura="tamanhoLargura"
			:tamanho-icone="tamanhoIcone"
			:cor-icone="corIcone"
			:cor-de-fundo="corDeFundo"
			@click="acessar"
		></botao-primario>
	</div>
</template>

<script>
import MenuAcoes from '@/views/components/MenuAcoes'
import IconeTooltip from '@/views/components/IconeTooltip.vue'

export default {
	name: 'botao-processo-digital',
	components: { IconeTooltip, MenuAcoes },
	props: {
		nomeBotao: {
			type: String,
			default: 'Processo Digital',
		},
		corDeFundo: {
			type: String,
			default: 'white',
		},
		icone: {
			type: String,
			default: 'mdi-open-in-new',
		},
		dark: {
			type: Boolean,
			default: false,
		},
		tamanhoIcone: {
			type: String,
			default: '0.9rem',
		},
		tamanhoIconeBadge: {
			type: String,
			default: '25',
		},
		tamanhoIconePrimary: {
			type: String,
			default: '0.9rem',
		},
		tamanhoIconeSecondary: {
			type: String,
			default: '1.2rem',
		},
		corIcone: {
			type: String,
			default: 'white',
		},
		corIconeBadge: {
			type: String,
			default: '#FFDE00',
		},
		outlined: {
			type: Boolean,
			default: true,
		},
		block: {
			type: Boolean,
			default: false,
		},
		tamanhoLargura: {
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		isEdocs: {
			type: Boolean,
			default: false,
		},
		isAtaCancelada: {
			type: Boolean,
			default: false,
		},
		tamanhoIconeMenu: {
			type: String,
			default: '18',
		},
		iconePrimary: {
			type: String,
			default: '',
		},
		iconeSecondary: {
			type: String,
			default: 'arrow_drop_down',
		},
	},
	data() {
		return {
			menuAcoesItens: this.getMenuAcoesItens(),
		}
	},
	methods: {
		acessar() {
			this.$emit('acessar')
		},
		enviarEdocs() {
			this.$emit('enviar-edocs')
		},
		getMenuAcoesItens() {
			return {
				nome: this.nomeBotao,
				itens: [
					{
						titulo: 'Acessar',
						evento: 'acessar',
					},
					{
						titulo: 'Enviar E-Docs',
						evento: 'enviar-edocs',
						isVisible: () => !this.isAtaCancelada,
					},
				],
			}
		},
	},
}
</script>

<style lang="stylus">
.tamanho-botao-menu-acoes .v-btn:not(.v-btn--round).v-size--default
	padding 0 .3rem 0 .5rem !important

.tamanho-botao-menu-acoes #idButtonMenuAcoes
	width var(--width-menu, 150px) !important
</style>
